import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideLead,
  GuideCard,
  GuideCardGrid,
  GuideBlockList,
} from "../GuideBlocks.js";

const DailyHabitsSection = ({ heading, accentIndex = 1 }) => (
  <GuidePanel sectionId="daily-habits" heading={heading} accentIndex={accentIndex}>
    <GuideLead>
      Mental clarity is developed through consistent habits rather than occasional breakthroughs.
    </GuideLead>
    <p className="guide-panel__p">
      A workable cadence: once a day, take one situation that is still occupying your attention and run
      it through four questions — what happened, what did I assume, what does the evidence say, and what
      will I do next. Ten minutes of this, three to four times a week, does more for clarity than any
      single breakthrough.
    </p>
    <GuideCardGrid columns={2}>
      <GuideCard iconKey="communication" title="Develop self-awareness" description="Notice your thoughts before accepting them as truth">
        <GuideBlockList
          items={[
            "What went through my mind?",
            "What evidence supports this thought?",
            "What assumptions am I making?",
          ]}
        />
      </GuideCard>
      <GuideCard iconKey="clarity" title="Question your thinking" description='Instead of "Why is this happening to me?" ask:'>
        <GuideBlockList
          items={[
            "What facts do I know?",
            "What story am I creating?",
            "What else could be true?",
          ]}
        />
      </GuideCard>
      <GuideCard iconKey="awareness" title="Notice early overload signals" description="Behavior often signals overload before you name the thought">
        <GuideBlockList
          items={[
            "Re-reading without sending",
            "Rehearsing conversations",
            "Switching tasks mid-decision",
            "Postponing simple choices",
          ]}
        />
      </GuideCard>
      <GuideCard iconKey="growth" title="Create thinking space" description="Schedule time without notifications, meetings, or digital noise">
        <p className="guide-panel__p">Mental clarity grows in moments of reflection, not constant stimulation.</p>
      </GuideCard>
    </GuideCardGrid>
  </GuidePanel>
);

export default DailyHabitsSection;
